var render = function render(){var _vm=this,_c=_vm._self._c;return _c('genelarama',{attrs:{"apiname":"GenelTanitimAra","aktifmi":_vm.aktifmi,"label":_vm.getLabel,"tip":_vm.tipToInt},model:{value:(_vm.Model),callback:function ($$v) {_vm.Model=$$v},expression:"Model"}})
}
var staticRenderFns = []

export { render, staticRenderFns }